import type { Team, TeamFormValues } from '../../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTeamsStore } from '../../model/teams/store'

/**
 * `POST /admin-api/teams` — create a team with its member list.
 */
export const useTeamCreate = async (payload: TeamFormValues): Promise<Team | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTeamsStore()

  const url = useAdminRoutes('admin.teams.create')

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, payload)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    toast.success(data.message)

    return data.data || null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setSaving(false)
  }
}
